import { CommentTextContent } from "./comment-text-content-types";

const commentImageRegex = /@IMAGE\(([0-9a-fA-F-]{36})\)/g;

/**
 * Parses the text content of a comment and returns the comment text and any image ids found in the text content.
 */
export function parseCommentTextContent(textContent: string): CommentTextContent {
    if (!textContent) {
        return { commentImageIds: [], commentText: "" };
    }

    // Get all the image ids from the text content
    const matches = [...textContent.matchAll(commentImageRegex)];

    let modifiedText = textContent;
    const commentImageIds = [];

    matches.forEach((commentImage) => {
        // Remove the image id from the text content
        modifiedText = modifiedText.replace(commentImage[0], "");
        // Add the image id to the list of image ids
        commentImageIds.push(commentImage[1]);
    });

    return { commentImageIds, commentText: modifiedText.trim() };
}

/** Adds the image ids to the end of the text content */
export function addCommentImageToTextContent(textContent: string, imageIds: string[]): string {
    const images = imageIds.map((imageId) => `@IMAGE(${imageId})`);
    return `${textContent} ${images.join(" ")}`.trim();
}
